import { Divider, type AutocompleteRenderGroupParams } from '@mui/material';

/**
 * Autocomplete props for a lookup picker's recently used values (lookup spec §4.3): the first
 * `recentCount` options, as `useLookupOptions` arranges them. No visible header — their place at
 * the top says what they are — only a divider before the rest of the page; `groupLabel` names the
 * group for assistive technology. The group's first option, the most recent value, is highlighted,
 * so Enter picks it. Nothing when there is no group. Shared by the form and grid pickers.
 */
export function recentGroupProps<T>(options: T[], recentCount: number, groupLabel: string) {
  if (recentCount === 0) return {};
  const recent = new Set(options.slice(0, recentCount));
  return {
    groupBy: (option: T) => (recent.has(option) ? groupLabel : ''),
    renderGroup: (params: AutocompleteRenderGroupParams) =>
      params.group ? (
        <li key={params.key}>
          <ul role="group" aria-label={params.group} style={{ padding: 0 }}>{params.children}</ul>
        </li>
      ) : (
        <li key={params.key}>
          <Divider />
          <ul style={{ padding: 0 }}>{params.children}</ul>
        </li>
      ),
    autoHighlight: true,
  };
}
